export const GET_WEATHER = 'GET_WEATHER';
export const GET_WEATHER_SUCCESS = 'GET_WEATHER_SUCCESS';
export const GET_WEATHER_ERROR = 'GET_WEATHER_ERROR';

export const SET_WEATHER_VIEW = 'SET_WEATHER_VIEW';